import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UpdateBannerComponent } from '@fleet/version';
import { KioskLayoutComponent } from './kiosk-layout.component';
import { RouterModule } from '@angular/router';
import { FuseLoadingBarModule } from '@fleet/fuse';
import { MatMenuModule } from '@angular/material/menu';
import { KioskExitModule } from '@fleet/kiosk';

@NgModule({
  declarations: [KioskLayoutComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    UpdateBannerComponent,
    RouterModule,
    FuseLoadingBarModule,
    MatMenuModule,
    KioskExitModule,
  ],
  exports: [KioskLayoutComponent],
})
export class KioskLayoutModule {}
